module.exports = __webpack_public_path__ + "img/img_intro_banner.5bddc741.png";